<template>
    <DataTable v-model="dataModel" :value="dataModel" showGridlines 
    :loading="!dataModel && mode != this.$FORM_MODE_CREATE" style="display: block;
    overflow-x: hide;
    overflow-y:scroll;
    max-height: 400px;
    white-space: normal;
    word-wrap: break-word;"
    >
    <template #empty>
     No records found
     </template>
     <Column v-for="col of dataRequestLog" :field="col.field" :header="col.header" :key="col.field">
       
<template #body="{ data }">

    <!-- ColumnName -->
    <span v-if="col.field === 'ColumnName'">
        {{ $t(removeUnderScore(data.ColumnName)) }}
    </span>

    <!-- TableName -->
    <span v-else-if="col.field === 'TableName'">
        {{ $t(data.TableName) }}
    </span>

    <!-- Date -->
    <span v-else-if="col.field.includes('Date')">
        {{ $formatDateTime(data[col.field]) }}
    </span>

    <!-- ValueFrom / ValueTo -->
    <span v-else-if="col.field === 'ValueFrom' || col.field === 'ValueTo'">

        <!-- Date / Tanggal -->
        <span
            v-if="
                data.ColumnName &&
                (
                    data.ColumnName.includes('Date') ||
                    data.ColumnName.includes('Tanggal')
                ) &&
                !data.ColumnName.includes('To_Date')
            "
        >
            {{ formatDate(data[col.field]) }}
        </span>

        <!-- Number -->
        <span
            v-else-if="
                data.ColumnName &&
                typeof convertToNumber(data[col.field]) === 'number' &&
                col.field !== 'ChangedBy'
            "
        >
            <span
                v-if="
                    data.ColumnName.includes('Nilai') ||
                    data.ColumnName.includes('Amount') ||
                    data.ColumnName.includes('Volume') ||
                    data.ColumnName.includes('Deviasi') ||
                    data.ColumnName.includes('Rounding') ||
                    data.ColumnName.includes('Total') ||
                    data.ColumnName.includes('To_Date') ||
                    data.ColumnName.includes('Price')
                "
            >
                {{ formatNumber(data[col.field]) }}
            </span>

            <span v-else>
                {{ formatNumber2(data[col.field]) }}
            </span>
        </span>

        <!-- Value biasa -->
        <span v-else>
            {{ data[col.field] }}
        </span>

    </span>

    <!-- Field lainnya -->
    <span v-else>
        {{ data[col.field] }}
    </span>

</template>
     </Column>
    </DataTable>
 </template>
 
 <script>
 
 export default {
     name: "RequestLogDataTable",
     props:{
        modelValue: {
            type:Object,
            default:Array
        },
        dataRequestLog:{
            type: Array,
            default:null
        },
        mode:{
            type: String,
            default:""
        },
        tableName:{
            type: String,
            default:""
        }
     },
     data(){
         return{
             dataModel :  this.modelValue != null ? this.filterData(this.modelValue) : null
         }
     },
     mounted(){
     
     },
     watch:{
        modelValue(value){
            this.dataModel = this.filterData(value)
        }
     },
     methods:{
        filterData(modelValue){
            var result = [];
            if(this.tableName == "WorkOrderCreation" || this.tableName == "WorkOrderClosing")
                result = modelValue.filter(record =>  !record.ColumnName  || ((record.ColumnName == 'Reason' && record.TableName == 'Doc_BA_Penalty') || (record.ColumnName && !record.ColumnName.includes("Is_Disable") && !record.ColumnName.includes("Id")) && (record.ColumnName != "Is_Deleted" || record.TableName == "Work_Order_SCOPE") && record.ColumnName != 'Created_Date' && record.ColumnName != 'Reason_Edit' && record.ColumnName != 'Reason'));
            else
                result = modelValue.filter(record =>  !record.ColumnName  || ((record.ColumnName == 'Reason' && record.TableName == 'Doc_BA_Penalty') || (record.ColumnName && !record.ColumnName.includes("Is_Disable") && !record.ColumnName.includes("Id")) && (record.ColumnName != "Is_Deleted" || record.TableName == "Work_Order_SCOPE") && record.ColumnName != 'Created_Date' && record.ColumnName != 'Status_Closing' && record.ColumnName != 'Status' && record.ColumnName != 'Reason_Edit' && record.ColumnName != 'Reason'));
            return result;
        },
        removeUnderScore(str){
            if (str.includes('_')) {  // Check if there is any underscore
                return str.replace(/_/g, ' ');  // Replace all underscores with spaces
            }
            return str;
        },
        convertToNumber(str) {
            if(!str) return str;
            // Fungsi untuk memeriksa apakah string dapat dikonversi ke angka
            function canConvertToNumber(str) {
                // Cek jika string bisa dikonversi ke angka yang valid
                return !isNaN(Number(str)) && isFinite(Number(str));
            }

            // Periksa dan konversi jika valid
            if (canConvertToNumber(str)) {
                return Number(str);
            } else {
                return str;
            }
            
        },
        formatNumber(value) {
            if (!value) {
                return '';
            }
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 3
            }).format(value);
        },
        formatNumber2(num) {
            // Check if the number is an integer

            if (!num) {
                return '';
            }
          
            if (num % 1 === 0) {
                return parseInt(num);
            }
                return num; // Return as is for other cases
        },
        formatDate(value) {
            if (!value) {
                return '';
            }

             const date = new Date(value);

            if (isNaN(date)){
                
                const dateParts = value.split(' ');
                const date = dateParts[0];
                const time = dateParts[1] ? dateParts[1].substring(0, 5) : '';
                return `${date}`; // ${time}
            };

            // Ambil tanggal: MM/DD/YYYY
            const dateStr = date.toLocaleDateString('en-US');

            // Ambil waktu: HH:mm (24 jam)
            const timeStr = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: false
            });

            return `${dateStr}`; //${timeStr}

        },
     }
 }
 
 </script>
 
 <style>
 /* Optional: Customize the table container */
 .table-container {
   max-height: 400px; /* Set the height of the table */
   overflow-y: auto;  /* Make the table body scrollable */
 }
 
 .p-datatable-thead {
   position: sticky;
   top: 0;
   z-index: 1;
 }
</style> 